export default __webpack_public_path__ + "static/media/guide0205_m.fdc0bc3b.jpg";